// @ts-nocheck
import Component, { ComponentAttrs } from 'flarum/common/Component';
import Mithril from 'mithril';
import { UserTimeLineAttrs } from '../types';
import app from 'flarum/forum/app';
import { getRelativeTimeString } from '../../utils/relativeTimeFormat';

export default class UserReputationHistory extends Component<UserTimeLineAttrs> {
  oninit(vnode: Mithril.Vnode<ComponentAttrs, this>) {
    super.oninit(vnode);
    this.loadUserTimeLine();
  }

  async loadUserTimeLine(): Promise<void> {
    try {
      const response: unknown = await app.request({
        method: 'GET',
        url: `${app.forum.attribute('apiUrl')}/reputation/user/${this.attrs.userId}`,
      });

      // @ts-ignore
      const userData = response.data[0].attributes;
      this.data = userData;

      this.reputationHistory = JSON.parse(userData.reputation_history);
      m.redraw();
    } catch (error) {
      console.warn('This user has no reputation yet');
    }
  }

  view(vnode: Mithril.Vnode<ComponentAttrs, this>): Mithril.Children {
    return (
      <div class="reputation-history-container">
        <div className="timeline-component">
          <div>
            {this.reputationHistory ? (
              <div class="all-timelines">
                {this.reputationHistory &&
                  this.reputationHistory?.slice(0, 15).map((entry: any) => {
                    return (
                      <div class="single-timeline d-flex-2">
                        <div class="timeline-blank"></div>
                        <div class="timeline-text d-flex-2">
                          <span>
                            <span>
                              {new Date(entry.timestamp).toLocaleDateString()} - {getRelativeTimeString(new Date(entry.timestamp))}
                            </span>
                            <span>{entry.reason}</span>
                          </span>
                          <div class="t-square"></div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <div>{app.translator.trans('justoverclock-reputation-score.forum.emptyReputationHistory')}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
